import { AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { EP } from "../configs/constant";
import { getShopUsername } from "../helpers/handleShopContext";

export function handleRequest(config: InternalAxiosRequestConfig) {
    const hostname = window.location.hostname;
    if (hostname === 'localhost') {
        config.headers[EP.DOMAIN] = 'store.lienvu.com';
    } else if (hostname.endsWith('.salekit.store')) {
        // username.salekit.store -> nhận diện shop bằng subdomain
        config.headers[EP.USERNAME] = hostname.split('.')[0];
    } else {
        // Tên miền riêng của store -> backend tra bảng domain để tìm shop
        config.headers[EP.DOMAIN] = hostname;
    }
    if (config.headers[EP.DOMAIN] && !config.headers[EP.USERNAME]) {
        const username = getShopUsername();
        if (username) config.headers[EP.USERNAME] = username;
    }
    return config;
}
export function handlError(error: any) {
    throw error;
}
export function handleSuccess(response: AxiosResponse<any>) {
    return response.data;
}